import React from 'react';
import RegulationCard from '../../../../../../v2/components/Cards/RegulationCard/RegulationCard';

const RegulationUpdate = ({ update }) => {
  return <RegulationCard regulation={update} />;
};

export default RegulationUpdate;
